import {
  useCallback,
  useMemo,
  useContext,
} from 'react';
import { useRouteMatch } from 'react-router-dom';
import { getFirestore } from 'firestorter';

import ChatChannel from '../../chat/Model/ChatChannel';
import { firestorePaths } from '../../utils/paths';
import LoggedInUserContext from '../../context/LoggedInUserContext';
import useSessionStore from '../../hooks/useSessionStore';

const useUpdateInteraction = (clientId) => {
  const {
    userDoc: {
      name: authUserName,
    },
    userId: authUserId,
  } = useContext(LoggedInUserContext);
  const { params: { userId: coachId } } = useRouteMatch();
  const { isCoachAssistant: isLoggedInUserCoachAssistant } = useSessionStore();

  const updateLastInteraction = useCallback(async () => {
    if (isLoggedInUserCoachAssistant && clientId && coachId) {
      const db = getFirestore();

      // Web/server-only fields — written to coachData.{coachId} only (no root twin).
      const userDocRef = db.collection(firestorePaths.USER).doc(clientId);
      await userDocRef.update({
        [`coachData.${coachId}.lastInteractionBy`]: authUserId,
        [`coachData.${coachId}.lastInteractionByUserName`]: authUserName,
      });

      // Update the client's channel with this coach: a reassigned client also keeps their old coach's channel
      const chatChannel = await ChatChannel.getUserCoachChannel(clientId, coachId);
      if (chatChannel) {
        await chatChannel.update({
          lastInteractionBy: authUserId,
        });
      }
    }
  }, [
    isLoggedInUserCoachAssistant,
    clientId,
    coachId,
    authUserId,
    authUserName,
  ]);

  return useMemo(() => ({
    updateLastInteraction,
  }), [
    updateLastInteraction,
  ]);
};

export default useUpdateInteraction;
